import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./LanguageSelection.css";
import UpArrow from "../../img/language-selection.svg";

const LanguageSelection = ({ languages, isHomepage }) => {
  const { i18n, t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("EN");

  const languageButtonRef = useRef(null);

  const normalizeLanguage = (language) =>
    (language || "en").split("-")[0].toUpperCase();

  useEffect(() => {
    document.documentElement.lang = (i18n.language || "en").split("-")[0];
    if (i18n?.language) {
      setSelectedLanguage(normalizeLanguage(i18n.language));
    }
  }, [i18n?.language]);

  const toggleLanguageSelection = () => {
    setIsOpen((previousIsOpen) => !previousIsOpen);
  };

  const handleLanguageSelect = (language) => {
    setSelectedLanguage(language);

    if (i18n?.changeLanguage) {
      i18n.changeLanguage(language.toLowerCase());
    }

    setIsOpen(false);
    requestAnimationFrame(() => languageButtonRef.current?.focus());
  };

  const handleKeyDown = (event) => {

    if (event.key === "Escape" || event.key === "Esc") {
      event.preventDefault();
      event.stopPropagation();

      setIsOpen(false);
      languageButtonRef.current?.focus();
    }
  };


  return (
    <div
      className={`language-selection ${isOpen ? "open" : ""}`}
      onKeyDown={handleKeyDown}
    >
      <button
        ref={languageButtonRef}
        type="button"
        onClick={toggleLanguageSelection}
        className="language-selection-button"
        aria-expanded={isOpen}
        aria-controls="language-selection-menu"
        aria-haspopup="true"
        aria-label={t("language")}
      >
        <div className="language-selection-selected-container">
          <div
            className={`language-selection-selected ${isHomepage ? "homepage" : ""
              }`}
          >
            {selectedLanguage}
          </div>

          {isOpen ? (
            <div className={`img-close ${isHomepage ? "homepage" : ""}`}>
              <img src={UpArrow} alt="" />
            </div>
          ) : (
            <div
              className={`img-close closed ${isHomepage ? "homepage" : ""
                }`}
            >
              <img src={UpArrow} alt="" />
            </div>
          )}
        </div>
      </button>

      {isOpen && (
        <div className="language-selection-menu-container">
          <ul
            id="language-selection-menu"
            className={`language-selection-menu ${isHomepage ? "homepage" : ""
              }`}
          >
            {languages
              .filter((language) => language !== selectedLanguage)
              .map((language, index, array) => (
                <React.Fragment key={language}>
                  <li>
                    <button
                      type="button"
                      onClick={() => handleLanguageSelect(language)}
                    >
                      {language}
                    </button>
                  </li>

                  {index < array.length - 1 && (
                    <li
                      className="separator-languages"
                      aria-hidden="true"
                    >
                      <div className="separator-languages-line" />
                    </li>
                  )}
                </React.Fragment>
              ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LanguageSelection;
